import React, { createContext, useContext, useState, useMemo } from 'react'
import { useOrganization } from '@context/OrganizationContext/OrganizationContext'
import { useDonationsData } from '@hooks/useDonationsData'
import {
  DonationsContextProps,
  DonationsContextDefaultValues,
} from '@Interfaces/Data/DonationInterface'
import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const DonationsContext = createContext<DonationsContextProps>(DonationsContextDefaultValues)

export const DonationsProvider = ({ children }: ContextComponentProps) => {
  const { selectedOrg } = useOrganization()
  const [, setGetDonations] = useState(false)
  const {
    recentDonations,
    ourDonations,
    setOurDonations,
    ourRecurringDonations,
    selectedDonation,
    setSelectedDonation,
  } = useDonationsData(selectedOrg)

  const contextValue = useMemo(
    () => ({
      recentDonations,
      setGetDonations,
      ourDonations,
      setOurDonations,
      ourRecurringDonations,
      selectedDonation,
      setSelectedDonation,
    }),
    [recentDonations, ourDonations, ourRecurringDonations, selectedDonation]
  )

  return <DonationsContext.Provider value={contextValue}>{children}</DonationsContext.Provider>
}

export const useDonations = (): DonationsContextProps => useContext(DonationsContext)
